const MuiFormControl = {
  styleOverrides: {
    root: {
      /* 
          Work around for 'Filter panel breaks layout on small display #5183'
          https://github.com/mui/mui-x/issues/5183
      */
      '&.MuiDataGrid-filterFormOperatorInput': {
        '@media (max-width: 600px)': {
          width: 150,
        },
      },
    },
  },
};

export default MuiFormControl;
